/**
 * @module cercaliagl/view/VInfoMap
 */

import $ from 'jquery';
import BaseView from './BaseView';

/**
 * @classdesc
 */
class VInfoMap extends BaseView {
  constructor() {
    const jqElement = $(`
    <div class="v-infomap mdc-elevation--z4">
      <div class="header"></div>
      <div class="content"></div>
      <div class="footer">
        <button type="button" class="mdc-button ok"><span class="mdc-button__ripple"></span>OK</button>
      </div>
    </div>`);

    super(jqElement);

    this.initialize_();
  }

  /**
   * @private
   */
  initialize_() {
    this.jqElement_.find('button.ok').click(() => this.hide());
  }

  /**
   * @param {string} title HTML title
   */
  setTitle(title) {
    this.jqElement_
      .find('.header')
      .empty()
      .html(title);
  }

  /**
   * @param {string} content content
   */
  setContent(content) {
    this.jqElement_
      .find('.content')
      .empty()
      .html(content);
  }
}

export default VInfoMap;
